module.exports = __webpack_public_path__ + "static/media/independent-validation.d5e79449.svg";